module.exports = __webpack_public_path__ + "img/tablet-1.dd162280.png";